import { queryKeys } from '@query/keys'
import { STALE_TIME } from '@query/queryClient'
import { useQuery } from '@tanstack/react-query'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

export const useDynamicLeverage = () => {
  const apiClient = useApiClient(ClientApiClient)

  return useQuery({
    queryKey: queryKeys.trade.dxtrade.dynamicLeverage(),
    queryFn: () => apiClient.getDynamicLeverage(),
    staleTime: STALE_TIME.SEMI_STATIC,
    gcTime: STALE_TIME.STATIC,
    refetchOnMount: false,
  })
}
